module.exports = __webpack_public_path__ + "img/2f_r_kokoro.a573eae3.jpg";